<template>
  <div>
    <audio src="" id="audio_word"></audio>
    <div
      class="switchAudio_box"
      v-for="(item, index) in content.content"
      :key="index"
    >
      <div class="switchAudio_top" v-show="index == currentIndex - 1">
        <div class="word_flex_box">
          <span v-for="items in item.popWordTitle" :key="items.key">{{
            items.text
          }}</span>
        </div>
        <img
          :src="
            !item.isPlay
              ? require('@/assets/images/books/book2/play_default.png')
              : require('@/assets/images/books/book2/play_process.png')
          "
          alt=""
          class="play_img"
          @click="audioPlayClick(item)"
        />
      </div>
      <div class="switchAudio_bottom" v-show="index == currentIndex - 1">
        <div
          class="content"
          v-for="item in item.popWordList"
          :key="item.key"
        >
          <div class="content_top" v-if="item.text">
            <span></span><span>{{ item.text }}</span>
          </div>
          <div class="content_bottom">
            <div v-for="(items, index) in item.content" :key="items.key">
              <template v-if="!items.textFlex">
                <span
                  v-for="ite in items.content"
                  :key="ite.key"
                  :style="{
                    fontFamily: ite.textStyle.fontFamily || '',
                    fontSize: ite.textStyle.fontSize + 'rem' || '',
                    color: ite.textStyle.color || '',
                    fontStyle: ite.textStyle.fontItalic === 1 ? 'italic' : '',
                    fontWeight: ite.textStyle.fontWeight || '',
                  }"
                  >{{ ite.text }}</span
                ></template
              >
              <template v-else>
                <div class="flex_box">
                  <div class="flex_left">
                    <span
                      :style="{
                        fontFamily:
                          item.content[index].content[0].textStyle.fontFamily ||
                          '',
                        fontSize:
                          item.content[index].content[0].textStyle.fontSize +
                            'rem' || '',
                        color:
                          item.content[index].content[0].textStyle.color || '',
                        fontStyle:
                          item.content[index].content[0].textStyle
                            .fontItalic === 1
                            ? 'italic'
                            : '',
                        fontWeight:
                          item.content[index].content[0].textStyle.fontWeight ||
                          '',
                      }"
                    >{{ item.content[index].content[0].text }}</span>
                  </div>
                  <div class="flex_right">
                    <span
                      v-for="(ite, ind) in items.content.slice(1)"
                      :key="ind"
                      :style="{
                        fontFamily: ite.textStyle.fontFamily || '',
                        fontSize: ite.textStyle.fontSize + 'rem' || '',
                        color: ite.textStyle.color || '',
                        fontStyle:
                          ite.textStyle.fontItalic === 1 ? 'italic' : '',
                        fontWeight: ite.textStyle.fontWeight || '',
                        display: 'block',
                      }"
                    >{{ ite.text }}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="progress" v-show="index == currentIndex - 1">
          <div class="current_topic">
            <!-- {{ (currentIndex+2 / content.content.length) * 100 + '%' }} -->

            <span
              class="current_topic_active"
              :style="{
                width: progressWidth + '%',
              }"
            ></span>
          </div>
          <div class="current_topic_number">
            <span>{{ index + 1 }}</span
            >/ <span>{{ content.content.length }}</span>
          </div>
        </div>
        <sound
          :key="index"
          v-if="item.soundContent"
          :content="item.soundContent"
          :statusSound="statusSound"
        ></sound>
        <div class="switch_footer">
          <span
            class="prev"
            @click.stop="previous"
            :class="currentIndex == 1?'disableActive':''"
            >上一个</span
          >
          <span
            class="next"
            @click.stop="next"
            ref="next"
            :class="currentIndex < content.content.length == 1?'':'disableActive'"
            >下一个</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
   
<script>
import sound from "./index.vue";
export default {
  data() {
    return {
      currentIndex: 0, //当前显示内容索引
      statusSound:true,
    };
  },
  components: {
    sound,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    progressWidth() {
      return (this.currentIndex / this.content.content.length) * 100;
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      if (this.content.content.length) {
        // this.$refs.next[0].click();
        if (this.currentIndex < this.content.content.length) {
          this.currentIndex++;
        }else{
          this.$message.error("已经是最后一个单词了！");
        }
      }
    });
  },
  methods: {
    next() {
      if (this.currentIndex < this.content.content.length) {
        this.currentIndex++;
      }else{
        this.$message.error("已经是最后一个单词了！");
      }
      // 调用函数停止所有正在播放的音频和视频
      this.stopAllMedia();
    },
     stopAllMedia() {
      // 获取页面上所有的audio和video元素
      const audios = document.getElementsByTagName('audio');
      const videos = document.getElementsByTagName('video');

      // 停止所有的audio元素
      for (let i = 0; i < audios.length; i++) {
        if (!audios[i].paused) {
          audios[i].pause();
        }
      }

      // 停止所有的video元素
      for (let i = 0; i < videos.length; i++) {
        if (!videos[i].paused) {
          videos[i].pause();
          // 可选：重置播放位置
          videos[i].currentTime = 0;
        }
      }
      this.statusSound = !this.statusSound;
    },
    previous() {
      if (this.currentIndex == 1) {
        this.$message.error("已经是第一个单词了！");
        return;
      }
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
      // 调用函数停止所有正在播放的音频和视频
      this.stopAllMedia();
    },
    //音频播放点击
    audioPlayClick(item) {
      item.isPlay = !item.isPlay;
      if (item.isPlay) {
        var audio = document.getElementById("audio_word");
        audio.src = item.word_url;
        audio.play();
      } else {
        var audio = document.getElementById("audio_word");
        audio.pause();
      }
      audio.addEventListener("ended", function () {
        console.log("音频播放完成");
        item.isPlay = false;
      });
    },
  },
};
</script>
   
<style scoped lang='scss'>
.switchAudio_box {
  width:100%;
  // border: 1rem solid #e3e3e3;
  border-radius: 10rem;
  .word_flex_box {
    span {
      display: inline-block;
      line-height: 36rem;
    }
    span:nth-child(1) {
      color: #333333;
      font-size: 32rem;
      min-width: 50%;
    }
    span:nth-child(2) {
      color: #999999;
      font-size: 26rem;
    }
  }
  .switchAudio_top {
    display: flex;
    background: #eaf4f0;
    padding: 30rem 32rem;
    justify-content: space-between;
    align-items: center;
    border: 1rem solid #e3e3e3;
    border-radius: 10rem 10rem 0 0;
    .word_flex_box {
      width: calc(100% - 48rem);
    }
    .play_img {
      width: 48rem;
      height: 48rem;
      cursor: pointer;
    }
  }
  .switchAudio_bottom {
    border: 1rem solid #e3e3e3;
    border-radius: 0 0 10rem 10rem;
    .content {
      margin-bottom: 16rem;
      width: calc(100% - 30rem);
      margin: 0 auto;
      .content_top {
        display: flex;
        align-items: center;
        margin-top: 35rem;
        span {
          display: inline-block;
        }
        span:nth-child(1) {
          width: 6rem;
          height: 26rem;
          background: #5ca683;
          border-radius: 3rem;
        }
        span:nth-child(2) {
          margin-left: 16rem;
          color: #333333;
          font-size: 28rem;
        }
      }
      .content_bottom {
        white-space: pre-wrap;
      }
    }
    .progress {
      margin-top: 60rem;
      .current_topic {
        width: 100%;
        height: 1rem;
        background: #e3e3e3;
        position: relative;
        .current_topic_active {
          background: #5ca683;
          height: 3rem;
          display: inline-block;
          position: absolute;
          top: -1.5rem;
          left: 0;
        }
      }
      .current_topic_number {
        color: #c1c1c1;
        display: flex;
        justify-content: flex-end;
        font-size: 28rem;
        padding-right: 10rem;
        span:nth-child(1) {
          color: #5ca683;
          font-weight: bold;
        }
      }
    }
  }
}
.flex_box {
  display: flex;
  align-items: baseline;
  .flex_left {
    // width: 45rem;
    white-space: pre-wrap;
    word-break: keep-all;
  }
  .flex_right {
    flex: 1;
    // margin-left: 10rem;
  }
}
.switch_footer {
  display: flex;
  span {
    display: inline-block;
    width: 50%;
    height: 88rem;
    line-height: 88rem;
    text-align: center;
    font-size: 26rem;
    cursor: pointer;
  }
  span:nth-child(1) {
    color: rgb(255, 255, 255);
    background:#5CA683;
    border-right:2rem solid #85C0A4;
  }
  span:nth-child(2) {
    color: rgb(255, 255, 255);
    background:#5CA683;
  }
}
.disableActive{
  background: rgb(241, 241, 241) !important;
  color: #cccccc !important;
}

</style>